import { render, staticRenderFns } from "./AnomalyGlobalTestModal.vue?vue&type=template&id=0dfa9882&scoped=true&"
import script from "./AnomalyGlobalTestModal.vue?vue&type=script&lang=js&"
export * from "./AnomalyGlobalTestModal.vue?vue&type=script&lang=js&"
import style0 from "./AnomalyGlobalTestModal.vue?vue&type=style&index=0&id=0dfa9882&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfa9882",
  null
  
)

export default component.exports